import { supabase } from "./supabaseClient";

export const isDualReviewImage = image =>
  Boolean(image && typeof image === "object" && image?.moderation?.mode === "dual" && image?.moderation?.pair_id);

export const pendingDualReviewImages = review =>
  (Array.isArray(review?.imagenes) ? review.imagenes : []).filter(
    image => isDualReviewImage(image) && !["original", "protected"].includes(image?.moderation?.selection),
  );

const invoke = async (name, body) => {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) throw error;
  if (data && typeof data === "object" && "ok" in data && data.ok === false) {
    throw new Error(data.error || "No se pudo completar la operación.");
  }
  return data;
};

export const loadOriginalReviewImagePreview = async assetId => {
  if (!assetId) throw new Error("Original no disponible.");
  const { data, error } = await supabase.functions.invoke("admin-review-image-preview", {
    body: { asset_id: assetId },
  });
  if (error) throw error;
  if (typeof Blob !== "undefined" && data instanceof Blob) return URL.createObjectURL(data);
  if (data instanceof ArrayBuffer) return URL.createObjectURL(new Blob([data]));
  if (data?.error) throw new Error(data.error);
  throw new Error("No se pudo interpretar la vista previa del original.");
};

export const selectReviewImageVariant = (reviewId, pairId, selection) =>
  invoke("admin-review-image-select", {
    review_id: reviewId,
    pair_id: pairId,
    selection,
  });

export const finalizeReviewImageModeration = (reviewId, comment = "") =>
  invoke("admin-review-image-finalize", {
    review_id: reviewId,
    comment: comment || null,
  });

export const cleanupDueReviewImages = (limit = 20) =>
  invoke("cleanup-review-images", { limit });
